import { render, staticRenderFns } from "./ManageSellerZoneDialog.vue?vue&type=template&id=1f4047b4&scoped=true"
import script from "./ManageSellerZoneDialog.vue?vue&type=script&lang=js"
export * from "./ManageSellerZoneDialog.vue?vue&type=script&lang=js"
import style0 from "./ManageSellerZoneDialog.vue?vue&type=style&index=0&id=1f4047b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4047b4",
  null
  
)

export default component.exports